// Palette aligned with the Prepare Report mockup and the Daily NAV Review Price dialog.
export const reportDialogColors = {
  navy: '#002443',
  ink: '#0D0D0F',
  inkSoft: '#707070',
  tabInactive: '#8B949E',
  pass: '#00B050',
  passWash: '#F3F5F7',
  fail: '#D32F2F',
  failWash: '#FDECEC',
  tableHeader: '#EEF2F6',
  zebra: '#F7F8FA',
  border: '#E3E8F0',
};

export const headerCellSx = {
  bgcolor: reportDialogColors.tableHeader,
  borderBottom: `1px solid ${reportDialogColors.border}`,
  color: reportDialogColors.inkSoft,
  fontSize: 12,
  fontWeight: 700,
  py: 1,
};

export const bodyCellSx = {
  borderBottom: 'none',
  color: reportDialogColors.ink,
  fontSize: 13,
  py: 1,
};

export const reportDialogTabSx = {
  mb: 2.5,
  minHeight: 36,
  '& .MuiTabs-indicator': {
    height: 3,
    backgroundColor: reportDialogColors.navy,
  },
  '& .MuiTab-root': {
    color: reportDialogColors.tabInactive,
    fontWeight: 600,
    minHeight: 36,
    px: 1.5,
    textTransform: 'none',
  },
  '& .Mui-selected': {
    color: reportDialogColors.navy,
  },
} as const;
